export default __webpack_public_path__ + "images/db604e25d17d4c7ce8ab53de957a6364-toneden_logo.svg";